// extracted by mini-css-extract-plugin
export default {"FeatureBlockNameWhite":"FeatureBlockName_FeatureBlockNameWhite__bR9hF","FeatureBlockNamePurple":"FeatureBlockName_FeatureBlockNamePurple__jFdUM"};